import itemsSettingsWidget from "./itemsSettingsWidget.js";
import session from "../../core/session.js";

/**
 * Widget displaying settings (dimensions, budgets) for the rows of a report.
 */
export default itemsSettingsWidget.subclass((that, my) => {
	my.itemSettingsRenderer = function (row) {
		return (html) => {
			html.render(my.dimensionPickerRenderer(row));
		};
	};

	my.getItems = function () {
		return my.report.getRows();
	};

	my.getDimensionTree = function () {
		return session.getPeriod().getYear().getDimensionTree();
	};
});
